import { Building2, Home, Router, User, type LucideIcon } from "lucide-react";

export interface NavItem {
  label: string;
  to: string;
  icon: LucideIcon;
}

export const navItems: NavItem[] = [
  { label: "Home", to: "/", icon: Home },
  { label: "Users", to: "/user", icon: User },
  { label: "Devices", to: "/device", icon: Router },
  { label: "Device Brands", to: "/device/brand", icon: Router },
  { label: "Organisations", to: "/organisation", icon: Building2 },
  { label: "LNS Management", to: "/lns", icon: Router },
];
